:host {
  border: var(--size-px) solid var(--pos-border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--size-8);
  max-width: var(--size-96);
  background: var(--pos-card-background);
}

svg {
  width: var(--size-8);
}

h2 {
  display: flex;
  align-items: center;
}

p {
  padding: var(--size-2);
}

.info {
  color: var(--color-grey-900);
  background-color: var(--color-blue-200);
}
.warn {
  color: var(--color-grey-900);
  background-color: var(--color-yellow-200);
}
